import React from 'react';

const FormatDate = (date) => {
        var d = new Date(date).toDateString();
        d = d.split(' ');
        return d[1] + ' ' + d[2] + ', ' + d[3];
    }
export default FormatDate;